import  {createGlobalStyle} from "styled-components";

export const GlobalStyles = createGlobalStyle`

    html{
        scroll-behavior: smooth;
        background-color: #FFFFFF;
        margin: 0;
        padding: 0;
        color: #44301E;
    }



`